// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".files__wrapper[data-v-29ea7317] {\n  margin-left: -6px;\n  margin-right: -6px;\n  margin-bottom: -15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.files .file[data-v-29ea7317] {\n  margin-left: 6px;\n  margin-right: 6px;\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
